import {EMPTY, READY, LOADING, UPDATING, ERROR} from 'module/constants';
import common from 'module/common';

const SET_PASSWORD = 'setPassword';
const SET_STATE = 'setState';

const state = {
  password: '',
};
const mutations = {
  [SET_PASSWORD](state, payload) {
    state.password = payload;
  }

}
const actions = {
  submitPassword({commit, rootState}, {email, password, token}) {
    return new Promise((resolve, reject) => {
      if (!email && !password || !token) {
        reject('Bad request');
      }

      common
          .httpPost('PasswordHandler')
          .recaptchaAction('changePassword')
          .data({
            action: 'changePassword',
            email: email,
            password: password,
            token: token,
          })
          .then((res) => {
            commit(SET_STATE, READY);
            resolve(res.data);
          }, (error) => {
            rootState.$router.push('/error');
            commit(SET_STATE, ERROR);
            reject();
          });
    });
  },
  resetPassword({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject('Email is required');
      }

      common
          .httpPost('PasswordHandler')
          .recaptchaAction('resetPassword')
          .data({
            action: 'resetPassword',
            email: payload,
          })
          .then((res) => {
            commit(SET_STATE, READY);
            resolve(res.data);
          }, (error) => {
            rootState.$router.push('/error');
            commit(SET_STATE, ERROR);
            reject();
          });
    });
  }
};
const getters = {
  password: state => state.password,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}